import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeSection = ({ user }) => {
  const getCurrentGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'صبح بخیر';
    if (hour < 17) return 'ظهر بخیر';
    return 'عصر بخیر';
  };

  return (
    <div className="bg-gradient-to-l from-blue-600 to-blue-800 rounded-xl p-6 text-white mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold mb-2">
            {getCurrentGreeting()}، {user?.name}
          </h1>
          <p className="text-blue-100 mb-4">به پنل کاربری ایرانداد خوش آمدید</p>
          <div className="flex items-center space-x-4 space-x-reverse">
            <div className="flex items-center space-x-2 space-x-reverse">
              <Icon name="Crown" size={20} className="text-yellow-300" />
              <span className="text-sm">{user?.plan}</span>
            </div>
            <div className="flex items-center space-x-2 space-x-reverse">
              <Icon name="Coins" size={20} className="text-yellow-300" />
              <span className="text-sm">{user?.credits} اعتبار باقی‌مانده</span>
            </div>
          </div>
        </div>
        <div className="hidden md:block">
          {/* <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center">
            <Icon name="Scale" size={40} className="text-white" />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;
